module.exports = __webpack_public_path__ + "img/pic3@2x.d5105843.png";